import {fetchGet} from "../libs/reqCommon"
const state = {
  plateform:[{  //平台
    platform_code:'TB'
  }],
  bydepartId:[],bydepartIdList:[],  //直属上级
  ProductClassify:[], //经营品类
  plateList:[],//所属平台
  dealernameList:[],//经销商下拉
  levelList:[{id:1,levelName:'一级经销商'},{id:2,levelName:'二级经销商'},{id:3,levelName:'三级经销商'},{id:4,levelName:'四级经销商'},{id:5,levelName:'五级经销商'}],
  // levelList:[{id:0,levelName:'全部'},{id:1,levelName:'一级经销商'},{id:2,levelName:'二级经销商'},{id:3,levelName:'三级经销商'},{id:4,levelName:'四级经销商'},{id:5,levelName:'五级经销商'}],
  areaList:[],
  getfuByIdsArr:[],//所在部门
  GetNotReadlistData:{list:[]},//消息
  selectStatusData:{list:[]},//工单
  getByIdFullData:{}
}

const	getters = {
  plateform: state => {
    return state.plateform;
  },
  bydepartId: state => {
    return state.bydepartId;
  },
  ProductClassify:state => {
    return state.ProductClassify;
  },
  plateList: state => {
    return state.plateList;
  },
  areaList: state => {
    for(var i=0;i<state.areaList.length;i++){
      if(state.areaList[i].dictName == "地图" && state.areaList[i].children)
      return state.areaList[i].children;
    }
  },
  getfuByIdsArr:state=>{
    return state.getfuByIdsArr
  },
  GetNotReadlistData:state=>{
    return state.GetNotReadlistData
  },
  selectStatusData:state=>{
    return state.selectStatusData
  },
  getByIdFullData:state=>{
    return state.getByIdFullData
  }
}
const	mutations = {
  getplateform(state,payLoad){
    state.plateform = payLoad
  },
  getByDepartId(state,payLoad){
    state.bydepartId = payLoad[0]
  },
  getProductClassify(state,payLoad){
    state.ProductClassify = payLoad
  },
  getplateList(state,payLoad){
    state.plateList = payLoad
  },
  getDealernameList(state,payLoad){
    state.dealernameList = payLoad
  },
  getAreaList(state,payLoad) {
    state.areaList = payLoad;
  },
  MgetfuByIds(state,payLoad){
    state.getfuByIdsArr = payLoad
  },
  GetNotReadlist(state,payLoad){
    state.GetNotReadlistData = payLoad
  },
  getSelectStatusData(state,payLoad){
    state.selectStatusData = payLoad
  },
  getByIdFull(state,payLoad){
   if(/,/.test(payLoad.productinfoid)){
    let productinfoid=payLoad.productinfoid.split(',')
    payLoad.productinfoid=productinfoid[1]
    payLoad.productOneId=productinfoid[0]
   }
    payLoad.handlepic=payLoad.handlepic?payLoad.handlepic.split(','):[]
    let status=Boolean(payLoad.status)
    let result=Boolean(payLoad.result)
      if(!payLoad.status)payLoad.status=0


       if(!status&&result&&payLoad.type==2){
        payLoad.status=12
      }
       if(!status&&!result&&payLoad.type==2){
        payLoad.status=11
      }
       if((!status&&!payLoad.type)){
        payLoad.status=0
      }
    state.getByIdFullData = payLoad
  },
}
const	actions = {
  reqPlateForm ({ commit }) {
    fetchGet("/hcm/search/itemlistInfo").then(res =>{
      commit('getplateform',res.data)
    });
  },
  reqByDepartId ({ commit }) {
      function handleTreeData(res){
        var bydepartIdList = [];
        let bydepartIdItem = res
        for (let i = 0; i < bydepartIdItem.length; i++) {
          if (bydepartIdItem[i].type == "dept"){
            bydepartIdItem[i].disabled = true
            if(bydepartIdItem[i].children){
              handleTreeData(bydepartIdItem[i].children)
            }
          }
          bydepartIdList.push(bydepartIdItem)
        }
        commit('getByDepartId',bydepartIdList)
      }
    fetchGet("/hcm/userout/getUserTreeByDepartId").then(res =>{
      handleTreeData(res.data)
    });
  },
  reqProductClassify({commit}) {
    fetchGet("/hcm/ProductClassify/list").then(res =>{
      commit('getProductClassify',res.data)
    });
  },
  reqDealernameList({commit},query) {
    fetchGet("/hcm/dealer/getlistOfBmc",query).then(res =>{
      commit('getDealernameList',res.data)
    });
  },
  reqPlateList ({ commit }) {
      return new Promise((r)=>{
        fetchGet("/hcm/sys/GetList",{dictcode:'platform'}).then(res =>{
          r(res.data)
          commit('getplateList',res.data)
      })
    });
  },
  getById(context,id){
    var query = {reportId:id};
    return new Promise((r, j) => {
      fetchGet("/hcm/hcmReport/getById",query).then(res =>{
        if(res.status==='10000'){
          for(let item of res.data.flowList){
            if(item.reportpic)item.reportpic=item.reportpic.split(',')
          }
          res.data.reportpic=res.data.reportpic?res.data.reportpic.split(','):[]
          context.commit('getByIdFull',res.data)
          r(res)
        }

      });
    }).catch((data) => {
      j(data);
    });


  },
  // 获取地区列表
  reqAreaList({commit}) {
    fetchGet("/hcm/sys/getTree").then(res =>{
      commit('getAreaList',res.data)
    });
  },
  GetNotReadlistGet({commit}){
    var query = {pageNo:1,pageSize:10000};
    return new Promise(r => {
      fetchGet("/hcm/hcmMessageCenter/Getlist",query).then(result =>{
        let unRead=0
        for(let item of result.data.content){
          // item.content=item.content
          ++unRead
        }
        let data={list:result.data.content,unRead:unRead}
        commit('GetNotReadlist',data)
        r()
      });
    })
  },
  GetselectStatus({commit}){
    fetchGet("/hcm/hcmWorkOrder/selectStatus").then(result =>{
    let data={list:result.data}
    let read=0
      for(let item of result.data){
        // if(item.adminstatus==0)
        ++read//未读
      }
      data.unRead=read
      commit('getSelectStatusData',data)
    });
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
